import { Box } from "@mui/material"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useBoolean } from "src/hooks/useBoolean"
import { AppDispatch, AppState } from "src/state"
import { Slippages, updateSlippageSelected } from "src/state/user"
import { formatSlippageToString } from "src/utils/slippage"
import SettingsIcon from "@mui/icons-material/Settings"
import SlippageSettingModal from "./SlippageSettingModal"

interface Props {
  hideSettings?: boolean
}

const SlippageRow = ({ hideSettings }: Props) => {
  const { t } = useTranslation()
  const { slippageSelected, slippageCustom } = useSelector(
    (state: AppState) => state.user,
  )
  const [
    showSlippageSettingModal,
    openSlippageSettingModal,
    closeSlippageModal,
  ] = useBoolean(false)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    if (!slippageCustom && !Object.keys(Slippages).includes(slippageSelected)) {
      dispatch(updateSlippageSelected(Slippages.One))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box display="flex" justifyContent="space-between">
      <Box display="flex" alignItems="center">
        <Box mr={0.5}>{t("Slippage Tolerance")}</Box>
        {!hideSettings && (
          <SettingsIcon
            onClick={openSlippageSettingModal}
            sx={{ cursor: "pointer" }}
          />
        )}
      </Box>
      <Box>{formatSlippageToString(slippageSelected, slippageCustom)}%</Box>
      {showSlippageSettingModal && (
        <SlippageSettingModal onClose={closeSlippageModal} />
      )}
    </Box>
  )
}

export default SlippageRow
